import { put, call, getContext, all, delay } from 'redux-saga/effects';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { joinFairPlay as joinFairPlayService, TJoinFairPlayResult } from '../../../services/moderationActionCheck';
import { joinFairPlayFail, joinFairPlayStart, joinFairPlaySuccess } from '../../../actions/fairPlay';

export function* joinFairPlay() {
  const httpApi: IHttpApi = yield getContext('httpApi');
  const logger: ILogger = yield getContext('logger');

  yield put(joinFairPlayStart());

  const [response]: [TJoinFairPlayResult] = yield all([
    call(joinFairPlayService, {
      httpApi,
      logger,
    }),
    // При быстром ответе сервера лоадер появляется на долю секунд, из-за чего происходит мерцание.
    // Для хорошего UX ограничиваем минимально возможное выполнение запроса
    delay(1000),
  ]);

  if (response.success) {
    yield put(joinFairPlaySuccess());
  } else {
    yield put(joinFairPlayFail(response.payload));
  }
}
